// 共通 enum (フロント・バック共用)。DB CHECK 制約と一致させること。

export const ROLE = {
  SUPER_ADMIN: "super_admin",
  ADMIN: "admin",
  STAFF: "staff",
  MEMBER: "member",
} as const;
export type Role = (typeof ROLE)[keyof typeof ROLE];

export const MEMBER_STATUS = {
  ACTIVE: "active",
  PAYMENT_FAILED: "payment_failed",
  SUSPENDED: "suspended",
  CANCELLED: "cancelled",
  PENDING_ACTIVATION: "pending_activation",
} as const;
export type MemberStatus = (typeof MEMBER_STATUS)[keyof typeof MEMBER_STATUS];

export const EVENT_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
  CLOSED: "closed",
  COMPLETED: "completed",
  ARCHIVED: "archived",
} as const;
export type EventStatus = (typeof EVENT_STATUS)[keyof typeof EVENT_STATUS];

export const PARTICIPATION_MODE = {
  OFFLINE: "offline",
  ONLINE: "online",
  HYBRID: "hybrid",
} as const;
export type ParticipationMode =
  (typeof PARTICIPATION_MODE)[keyof typeof PARTICIPATION_MODE];

// イベント地域。現状は3拠点。将来は都道府県→全国へ「このリストに追加するだけ」で拡張可。
// DB(events.region) は CHECK 無しの TEXT なので値の追加にマイグレーション不要。
export const EVENT_REGIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: "osaka", label: "大阪" },
  { value: "nagoya", label: "名古屋" },
  { value: "tokyo", label: "東京" },
  { value: "ehime", label: "愛媛" },
];
export function regionLabel(v: string | null | undefined): string {
  if (!v) return "";
  return EVENT_REGIONS.find((r) => r.value === v)?.label ?? v;
}

export const APPLICATION_STATUS = {
  PENDING_PAYMENT: "pending_payment",
  APPLIED: "applied",
  CANCELLED: "cancelled",
  CHECKED_IN: "checked_in",
  NO_SHOW: "no_show",
} as const;
export type ApplicationStatus =
  (typeof APPLICATION_STATUS)[keyof typeof APPLICATION_STATUS];

export const PAYMENT_STATUS = {
  UNPAID: "unpaid",
  PAID: "paid",
  REFUNDED: "refunded",
  EXTERNAL: "external",
  NOT_REQUIRED: "not_required",
} as const;
export type PaymentStatus =
  (typeof PAYMENT_STATUS)[keyof typeof PAYMENT_STATUS];

export const CONTENT_TYPE = {
  VIDEO: "video",
  ARTICLE: "article",
  PDF: "pdf",
  EXTERNAL_LINK: "external_link",
} as const;
export type ContentType = (typeof CONTENT_TYPE)[keyof typeof CONTENT_TYPE];

export const CONTENT_STATUS = {
  DRAFT: "draft",
  PUBLISHED: "published",
  PRIVATE: "private",
  ARCHIVED: "archived",
} as const;
export type ContentStatus =
  (typeof CONTENT_STATUS)[keyof typeof CONTENT_STATUS];

export const SUBSCRIPTION_STATUS = {
  TRIALING: "trialing",
  ACTIVE: "active",
  PAST_DUE: "past_due",
  CANCELLED: "cancelled",
  EXPIRED: "expired",
} as const;
export type SubscriptionStatus =
  (typeof SUBSCRIPTION_STATUS)[keyof typeof SUBSCRIPTION_STATUS];

// 業務ルール: 会員サイトを利用できる member_status
export const MEMBER_STATUSES_LOGIN_ALLOWED: ReadonlyArray<MemberStatus> = [
  MEMBER_STATUS.ACTIVE,
  MEMBER_STATUS.PAYMENT_FAILED, // 決済復旧導線のため login は許可、機能は制限
  MEMBER_STATUS.PENDING_ACTIVATION,
];

// 業務ルール: 主要機能を利用できる member_status
export const MEMBER_STATUSES_FULL_ACCESS: ReadonlyArray<MemberStatus> = [
  MEMBER_STATUS.ACTIVE,
];
